import { Body, Eyebrow, Headline, Img, Wordmark, arch, frame, sans, serif, type DesignProps } from './designParts';

/** Instagram: posts (1080 × 1350) en story (1080 × 1920). */

export function PhotoDesign({
  d,
  p,
  w,
  h,
  city
}: DesignProps) {
  return <div style={frame(w, h, p.bg)} data-id="element-3187" data-mp="1eiobqe3dngsx">
      <div style={{
      height: '58%',
      flexShrink: 0
    }} data-id="element-3188" data-mp="1ejpul4qmx7l7">
        <Img src={d.image} data-id="element-3189" data-mp="19k3iiymjlxdz" />
      </div>
      <div style={{
      flex: 1,
      padding: '64px 80px 64px',
      display: 'flex',
      flexDirection: 'column',
      gap: 24
    }} data-id="element-3190" data-mp="19l4tz47h0lw8">
        <Eyebrow text={d.eyebrow} p={p} size={28} data-id="element-3191" data-mp="227h6w8c6dkmh" />
        <Headline d={d} p={p} size={78} data-id="element-3192" data-mp="228sekj8qrciv" />
        <Body text={d.body} p={p} size={30} maxWidth="88%" data-id="element-3193" data-mp="1xgr32zjedptw" />
        <div style={{
        marginTop: 'auto',
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'space-between'
      }} data-id="element-3194" data-mp="1xf67d6lck0ug">
          <Wordmark size={34} color={p.fg} city={city} data-id="element-3195" data-mp="1sfjwh3szqwot" />
          {d.cta && <span style={{
          fontFamily: sans,
          fontSize: 26,
          color: p.fg,
          borderBottom: `2px solid ${p.accent}`,
          paddingBottom: 4
        }} data-id="element-3196" data-mp="2pyml6j2gw4uo">{d.cta}</span>}
        </div>
      </div>
    </div>;
}
export function QuoteDesign({
  d,
  p,
  w,
  h,
  city
}: DesignProps) {
  return <div style={{
    ...frame(w, h, p.bg),
    padding: 96
  }} data-id="element-3197" data-mp="1oc2kgcytx0se">
      <div style={{
      fontFamily: serif,
      fontSize: 260,
      lineHeight: 0.8,
      color: p.accent,
      height: 150
    }} data-id="element-3198" data-mp="1odnbhslxq1li">“</div>
      <p style={{
      fontFamily: serif,
      fontWeight: 300,
      fontSize: 80,
      lineHeight: 1.12,
      letterSpacing: '-0.015em',
      color: p.fg,
      margin: '40px 0 0'
    }} data-id="element-3199" data-mp="1fjippnlnrgcu">
        {d.headline}
      </p>
      <div style={{
      marginTop: 'auto',
      display: 'flex',
      alignItems: 'center',
      gap: 32
    }} data-id="element-3200" data-mp="15j8bbznw02w3">
        {d.image && <div style={{
        width: 150,
        height: 150,
        borderRadius: 999,
        overflow: 'hidden',
        flexShrink: 0,
        border: `4px solid ${p.soft}`
      }} data-id="element-3201" data-mp="rnwffoxzw6dl">
            <Img src={d.image} width={400} data-id="element-3202" data-mp="2lzb9uj1yatzo" />
          </div>}
        <div style={{
        flex: 1
      }} data-id="element-3203" data-mp="2qynserlshewg">
          <p style={{
          fontFamily: serif,
          fontStyle: 'italic',
          fontSize: 36,
          color: p.fg,
          margin: 0
        }} data-id="element-3204" data-mp="2qxmi4pclkwfs">{d.body}</p>
        </div>
        <Wordmark size={30} color={p.fg} city={city} sub="" data-id="element-3205" data-mp="2olbzi79nugld" />
      </div>
    </div>;
}
export function TipDesign({
  d,
  p,
  w,
  h,
  city
}: DesignProps) {
  return <div style={{
    ...frame(w, h, p.bg),
    padding: '88px 88px 80px'
  }} data-id="element-3206" data-mp="2fij8840ha4vj">
      <div style={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'baseline'
    }} data-id="element-3207" data-mp="2ak7z5vi0byed">
        <span style={{
        fontFamily: sans,
        fontSize: 26,
        fontWeight: 500,
        color: p.bg,
        background: p.fg,
        padding: '10px 22px',
        borderRadius: 999
      }} data-id="element-3208" data-mp="38805bez1m9y3">
          {d.eyebrow || 'Huidtip'}
        </span>
        <Wordmark size={28} color={p.fg} city={city} sub="" data-id="element-3209" data-mp="2tjdkixqncpzh" />
      </div>
      <div style={{
      marginTop: 96
    }} data-id="element-3210" data-mp="2th9f2bd3nix3">
        <Headline d={d} p={p} size={104} data-id="element-3211" data-mp="3qyrby8rnbm8s" />
      </div>
      {d.points.length > 0 && <ul style={{
      listStyle: 'none',
      padding: 0,
      margin: '72px 0 0'
    }} data-id="element-3212" data-mp="3m79brmxg5pov">
          {d.points.map((pt, i) => <li key={i} style={{
        display: 'flex',
        gap: 28,
        alignItems: 'baseline',
        padding: '26px 0',
        borderTop: `2px solid ${p.fg}22`,
        fontFamily: sans,
        fontSize: 34,
        color: p.fg,
        lineHeight: 1.3
      }} data-id="element-3213" data-mp="3tjpem055lqju" data-mpi={i}>
              <span style={{
          fontFamily: serif,
          fontSize: 38,
          color: p.accent,
          width: 36,
          flexShrink: 0
        }} data-id="element-3214" data-mp="gbcikiskr9vc">{i + 1}</span>
              {pt}
            </li>)}
        </ul>}
      {d.body && <div style={{
      marginTop: 'auto',
      background: p.soft,
      padding: '32px 40px',
      borderRadius: 20
    }} data-id="element-3215" data-mp="q38ky61p1m5d">
          <Body text={d.body} p={p} size={30} data-id="element-3216" data-mp="uzyyalm463n3" />
        </div>}
    </div>;
}
export function ProductDesign({
  d,
  p,
  w,
  h,
  city,
  product,
  price
}: DesignProps) {
  return <div style={{
    ...frame(w, h, p.bg),
    padding: '80px 88px'
  }} data-id="element-3217" data-mp="1416vt1gt30g4">
      <div style={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'baseline'
    }} data-id="element-3218" data-mp="21quxqx95y8ac">
        <Eyebrow text={d.eyebrow} p={p} size={28} data-id="element-3219" data-mp="1wrrrj9hg5w0s" />
        <span style={{
        fontFamily: sans,
        fontSize: 26,
        color: p.fg
      }} data-id="element-3220" data-mp="1wqys6tkti8so">{product?.brand}</span>
      </div>
      <div style={{
      ...arch(560),
      background: p.soft,
      width: 560,
      height: 620,
      margin: '48px auto 0',
      padding: 60
    }} data-id="element-3221" data-mp="2ahvanrl159m0">
        <Img src={product?.image ?? ''} fit="contain" width={900} data-id="element-3222" data-mp="26icwdenprws5" />
      </div>
      <div style={{
      marginTop: 56,
      textAlign: 'center'
    }} data-id="element-3223" data-mp="1iss60ap8dx8u">
        <Headline d={d} p={p} size={70} data-id="element-3224" data-mp="1dt5se05hqezi" />
        <div style={{
        marginTop: 20,
        display: 'flex',
        justifyContent: 'center'
      }} data-id="element-3225" data-mp="1dugs9ovtf2lc">
          <Body text={d.body} p={p} size={30} maxWidth={820} data-id="element-3226" data-mp="1rtq6ij0gnmmo" />
        </div>
      </div>
      <div style={{
      marginTop: 'auto',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-end',
      borderTop: `2px solid ${p.fg}22`,
      paddingTop: 32
    }} data-id="element-3227" data-mp="1mtavvz7kct8e">
        <Wordmark size={30} color={p.fg} city={city} data-id="element-3228" data-mp="2yatutfe42a15" />
        <div style={{
        textAlign: 'right',
        color: p.fg
      }} data-id="element-3229" data-mp="36oos71nmgfr3">
          <div style={{
          fontFamily: serif,
          fontSize: 52,
          lineHeight: 1
        }} data-id="element-3230" data-mp="3ard1tbk5tqp4">{price}</div>
          {d.cta && <div style={{
          fontFamily: sans,
          fontSize: 24,
          marginTop: 10
        }} data-id="element-3231" data-mp="2wrk42wa7ua7n">{d.cta}</div>}
        </div>
      </div>
    </div>;
}

/** Zoveel producten passen er in een protocolontwerp. */
const MAX_ROUTINE_ITEMS = 5;
export function RoutineDesign({
  d,
  p,
  w,
  h,
  city,
  routine
}: DesignProps) {
  const items = routine?.items ?? [];
  return <div style={{
    ...frame(w, h, p.bg),
    padding: '80px 88px'
  }} data-id="element-3232" data-mp="3ueaqlmw66qy1">
      <div style={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'baseline'
    }} data-id="element-3233" data-mp="3fqfwq36fegjd">
        <Eyebrow text={d.eyebrow} p={p} size={28} data-id="element-3234" data-mp="3kpj2xqy56ssx" />
        <Wordmark size={28} color={p.fg} city={city} sub="" data-id="element-3235" data-mp="3ko7xlmp1tczp" />
      </div>
      <div style={{
      marginTop: 56
    }} data-id="element-3236" data-mp="c9fu3hvamy30">
        <Headline d={d} p={p} size={86} accentSize={60} data-id="element-3237" data-mp="c8ei9b6ge7k8" />
      </div>
      <Body text={d.body} p={p} size={30} maxWidth="85%" data-id="element-3238" data-mp="h1hejr2m7v44" />
      <ol style={{
      listStyle: 'none',
      padding: 0,
      margin: '48px 0 0',
      display: 'flex',
      flexDirection: 'column',
      gap: 18
    }} data-id="element-3239" data-mp="qwej766ohgek">
        {items.slice(0, MAX_ROUTINE_ITEMS).map((it, i) => <li key={it.id} style={{
        display: 'flex',
        alignItems: 'center',
        gap: 28
      }} data-id="element-3240" data-mp="lvih8y5w04bs" data-mpi={i}>
            <span style={{
          fontFamily: serif,
          fontSize: 40,
          color: p.accent,
          width: 34
        }} data-id="element-3241" data-mp="gwfejkddqa6z">{i + 1}</span>
            <div style={{
          width: 112,
          height: 112,
          background: p.soft,
          borderRadius: 16,
          padding: 12,
          flexShrink: 0
        }} data-id="element-3242" data-mp="cypxjw4se58g">
              <Img src={it.image} fit="contain" width={300} data-id="element-3243" data-mp="36u10picmn6c" />
            </div>
            <div style={{
          minWidth: 0
        }} data-id="element-3244" data-mp="34r0vcnhfdnw">
              <div style={{
            fontFamily: sans,
            fontSize: 22,
            color: p.fg
          }} data-id="element-3245" data-mp="3ucdadlwvuaco">{it.step ?? it.category}</div>
              <div style={{
            fontFamily: serif,
            fontSize: 34,
            color: p.fg,
            lineHeight: 1.15
          }} data-id="element-3246" data-mp="3petn5wi7in8l">{it.name}</div>
            </div>
          </li>)}
      </ol>
      <div style={{
      marginTop: 'auto',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'baseline',
      borderTop: `2px solid ${p.fg}22`,
      paddingTop: 28,
      color: p.fg
    }} data-id="element-3247" data-mp="3le9o2ne2p9jt">
        <span style={{
        fontFamily: sans,
        fontSize: 26
      }} data-id="element-3248" data-mp="20sl3borqnebq">{d.cta}</span>
        <span style={{
        fontFamily: serif,
        fontSize: 52
      }} data-id="element-3249" data-mp="24x2n3ny3lrmi">{routine?.price}</span>
      </div>
    </div>;
}
export function StoryDesign({
  d,
  p,
  w,
  h,
  city
}: DesignProps) {
  return <div style={frame(w, h, p.bg)} data-id="element-3250" data-mp="1d5d7dxg79hmd">
      <div style={{
      height: '56%',
      flexShrink: 0,
      padding: '96px 72px 0'
    }} data-id="element-3251" data-mp="1d6en4f85usaf">
        <div style={{
        ...arch(936),
        height: '100%'
      }} data-id="element-3252" data-mp="1h7gmqx5zp6cx">
          <Img src={d.image} data-id="element-3253" data-mp="1m5i5fgzi73nv" />
        </div>
      </div>
      <div style={{
      flex: 1,
      padding: '72px 88px 150px',
      display: 'flex',
      flexDirection: 'column',
      gap: 30
    }} data-id="element-3254" data-mp="1m4qbsbpgvg08">
        <Eyebrow text={d.eyebrow} p={p} size={34} data-id="element-3255" data-mp="1qxjd0plq867k" />
        <Headline d={d} p={p} size={104} data-id="element-3256" data-mp="the04wkugslp" />
        <Body text={d.body} p={p} size={38} data-id="element-3257" data-mp="tgb5qeobc811" />
        <div style={{
        marginTop: 'auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
      }} data-id="element-3258" data-mp="yfnux62npr6s">
          {d.cta && <span style={{
          fontFamily: sans,
          fontSize: 36,
          fontWeight: 500,
          background: p.fg,
          color: p.bg,
          padding: '26px 48px',
          borderRadius: 999
        }} data-id="element-3259" data-mp="3nysiucxsz7oe">
              {d.cta}
            </span>}
          <Wordmark size={34} color={p.fg} city={city} sub="" data-id="element-3260" data-mp="ar7j68mnasr8" />
        </div>
      </div>
    </div>;
}